import { createContext } from 'react';

export const createNullableContext = <T>() => createContext<T | null>(null);
